module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_add"
  }, [_c('div', {
    staticClass: "changead"
  }, [_c('div', {
    staticClass: "changeadinput"
  }, [_c('el-form', {
    attrs: {
      "label-position": _vm.labelPosition,
      "label-width": "100px",
      "model": _vm.changepassword
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请输入新密码",
      "type": _vm.change
    },
    model: {
      value: (_vm.changepassword.newpassword),
      callback: function($$v) {
        _vm.$set(_vm.changepassword, "newpassword", $$v)
      },
      expression: "changepassword.newpassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "请确认新密码",
      "type": _vm.change
    },
    model: {
      value: (_vm.changepassword.turePassword),
      callback: function($$v) {
        _vm.$set(_vm.changepassword, "turePassword", $$v)
      },
      expression: "changepassword.turePassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sumbit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.pageback
    }
  }, [_vm._v("取消")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-47e3c006"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/changeAdPw.vue
// module id = 532
// module chunks = 1